import React from 'react'
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToTop = () => {
  const location = useLocation()
  const prevLocation = useRef<string | null>()

  useEffect(() => {
    if (prevLocation.current !== location.pathname) {
      try {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
      } catch (error) {
        window.scrollTo(0, 0)
      }
      prevLocation.current = location.pathname
    }
  }, [location])

  return <></>
}

export default ScrollToTop
